@use 'styles/utils/variables' as *;

span.ant-typography {
  color: $text-color-primary;
  font-weight: normal;

  &.strong {
    font-weight: 600;
  }

  &.small {
    font-size: var(--fontSize-base);
    line-height: 1.6rem;
  }

  &.middle {
    font-size: var(--fontSize-base);
    line-height: 1.6rem;
  }

  &.large {
    font-size: 1.6rem;
    line-height: 1.8rem;
  }

  &.ant-typography-secondary {
    color: $text-color-secondary-dark;
  }

  &.ant-typography-success {
    color: $text-on-tint-success;
  }

  &.ant-typography-warning {
    color: $text-on-tint-warning;
  }

  &.ant-typography-danger {
    color: $text-on-tint-danger;
  }
}
